import React, { Component } from "react";
import PropTypes, { any } from "prop-types";
import Select from "react-select";
import TextField from "Components/forms/text-field/TextField.jsx";
import SelectInput from "Components/forms/select-input/SelectInput.jsx";
import Label from 'Components/forms/label/Label';
import "./AutoCompleteDropdown.scss";

class AutoCompleteDropdown extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="dropdown-selection comments-padding">
        {this.props.isSelectInputRequired &&
          <TextField
            fieldClass="field--fixed-width"
            htmlFor="transferCase"
            width={this.props.selectInputWidth}
            labelContent={<span data-radium>
              <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }} htmlFor="purpose-of-transfer-list" labelClass="field-label checkbox-group-parent-label-note dropdown-label">{this.props.selectInputLabel}</Label>
            </span>}
          >
            <div style={{ paddingTop: 13 }}>
              <SelectInput
                selectClass={{ zIndex: 1 }}
                dataList={this.props.selectInputDropdownList}
                wrapperClass="select-menu__form reports"
                extraClass="option-box"
                optionTextWrapCssClass={"merchant-message-wrapper option-text-wrap"}
                handleSelection={this.props.handleDropdownSelection}
                selectedItem={this.props.selectedDropdownValue}
              />
            </div>
          </TextField>
        }
        <TextField
          fieldClass="field--fixed-width"
          htmlFor="dropDownSearch"
          width={this.props.selectInputWidth}
          labelContent={<span data-radium>
            <Label extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }} htmlFor="operators-list" labelClass="field-label operator-padding dropdown-label">{this.props.searchDropdownLabel}</Label>
          </span>}
        >
          <div style={{ paddingTop: 13 }}>
          <div className="searchDropdown" style={{marginLeft: 40}}>
            <Select
              options={this.props.searchDropDownList}
              onChange={this.props.handleSearchDropdownSelection}
              placeholder=""
              className="searchDropdown"
              classNamePrefix="gp-select"
            />
          </div>
          </div>
        </TextField>
      </div>
    );
  }
}

AutoCompleteDropdown.props = {
  handleDropdownSelection: PropTypes.func.isRequired,
  handleSearchDropdownSelection: PropTypes.func.isRequired,
  selectedDropdownValue: PropTypes.object.isRequired,
  selectedSearchDropdown: PropTypes.object.isRequired,
  searchDropDownList: PropTypes.array.isRequired,
  selectInputDropdownList: PropTypes.array.isRequired,
  searchDropdownLabel: PropTypes.string.isRequired,
  selectInputWidth: PropTypes.string.isRequired,
  selectInputLabel: PropTypes.string,
  isSelectInputRequired: PropTypes.bool,
};

AutoCompleteDropdown.defaultProps = {
  isSelectInputRequired: false,
  selectInputLabel: "",
};

export default AutoCompleteDropdown;
